import {useNotificationStore} from '../features/notifications/hooks/useNotificationStore';
import {UI_CONFIG} from '../constants/appConfig';

/**
 * Clean notification hook that follows project patterns
 * Uses Zustand store instead of service to prevent infinite loops
 * Durations are read from UI_CONFIG for consistency.
 */
export const useNotification = () => {
  const {addNotification} = useNotificationStore();

  return {
    success: (message: string, details?: string) =>
      addNotification({
        type: 'success',
        message,
        details,
        duration: UI_CONFIG.SUCCESS_NOTIFICATION_DURATION
      }),
    error: (message: string, details?: string) =>
      addNotification({
        type: 'error',
        message,
        details,
        duration: UI_CONFIG.ERROR_NOTIFICATION_DURATION
      }),
    warning: (message: string, details?: string) =>
      addNotification({
        type: 'warning',
        message,
        details,
        duration: UI_CONFIG.WARNING_NOTIFICATION_DURATION
      }),
    info: (message: string, details?: string) =>
      addNotification({
        type: 'info',
        message,
        details,
        duration: UI_CONFIG.SUCCESS_NOTIFICATION_DURATION
      })
  };
};
